import { Component, OnInit, Input } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';
import { IndependenceModel } from '../../declaration.model';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-annual',
  templateUrl: './annual.component.html',
  styleUrls: ['./annual.component.css'],
})
export class AnnualComponent implements OnInit {
  @Input() isMyReport: boolean;
  @Input() annualIndependence: IndependenceModel;

  financialList;
  employeeList;

  selectedFinancialYear;
  selectedProfile = '1';
  selectedEmployee;

  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) {}

  ngOnInit(): void {
    this.selectedFinancialYear="";
    this.selectedEmployee="";

    if (!this.isMyReport) {
      this.loadInitDetails();
      this.onProfileChanged();
    }
  }
  loadInitDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onProfileChanged() {
    if (this.selectedProfile != null && this.selectedProfile != undefined) {
      this.masterDataService
        .getUserByProfile(this.selectedProfile)
        .subscribe((res) => {
          //this.reportList =res[0].role;
          this.employeeList = res;
        });
    }
  }

  showExcelButton:Boolean;
  onViewReport() {
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear==""||
      this.selectedProfile == null ||
      this.selectedProfile == undefined ||
      this.selectedEmployee == null ||
      this.selectedEmployee == undefined||
      this.selectedEmployee==""
    )
       this.commonMessageService.swalAlertWithoutIcon('','Please choose the values before pressing report');
    else {
      this.masterDataService
        .getAnnualIndependence(
          this.selectedFinancialYear.id,
          this.selectedEmployee.id,
          this.selectedProfile
        )
        .subscribe((res) => {
          this.annualIndependence = res;
          console.log('post assign res',res);
         if(this.annualIndependence== null){
            this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");
           this.showExcelButton=false;
         }else{
           this.showExcelButton=true;
         }
        });
    }
  }
  validateAggreQuestion(answer){
    if(answer==1){
      return true;
    }else{
      return false;
    }

  }

  onExportToExcelReport(){
    this.masterDataService.getAnnualIndependenceExcel(this.selectedFinancialYear.id,
      this.selectedEmployee.id,
      this.selectedProfile).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "PostAssignmentDeclaration.xlsx";
      link.click();
    });
  }

  exportToPDFClick(){
    var docDefinition = {
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'Annual Firm Personnel Independence Confirmation', fontSize: 18, bold: true, alignment: 'center', margin: [0, 15, 0, 15] });
    docDefinition.content.push({text: `Name of Article/Employee/Partner:${'                      '}${this.annualIndependence.firstName} ${this.annualIndependence.lastName}`,bold:true,margin: [0, 5, 0, 5]});
    docDefinition.content.push({text: `Designation:${'                                                              '} ${this.annualIndependence.role}`,bold:true,margin: [0, 5, 0, 5]});
    docDefinition.content.push({text: `Date Of Joining:${'                                                         '}${moment(this.annualIndependence.joiningDate).format('DD-MMM-yyyy')}`,bold:true,margin:[0, 5, 0, 5]});
    docDefinition.content.push({text: `Branch:${'                                                                        '}${this.annualIndependence.branch}`,bold:true,margin:[0, 5, 0, 5]});
    docDefinition.content.push({text: `For assignments in respect of FY:${'                          '}${this.annualIndependence.fyName}`,bold:true,margin:[0, 5, 0, 0]});
    docDefinition.content.push({text: 'DETAILED DECLARATIONS',margin:[0, 15, 0, 5]});
    docDefinition.content.push({text: `${this.annualIndependence.beginText}`,bold:true,margin:[0, 5, 0, 10]});

    docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: [40, '*', 60],
          body: [
            [{ text: 'Sr. No', bold:true, margin: [0, 5, 0, 5] }, { text: 'Declaration', bold:true, margin: [0, 5, 0, 5] }, { text: '	Agree / Disagree', bold:true, margin: [0, 5, 0, 5] }],
            ...this.annualIndependence.empIndepenDeclarationDetails.map((res,index) => [{ text:index+1 }, { text: res.question},  { text: `${res.answer?'Yes':'No'}`}]),
           
          ]
        }
      }
      );
      docDefinition.content.push({text: 'Explanation in cases where disagree responses are given',margin:[0, 15, 0, 0],bold:true});
      docDefinition.content.push({text: `${this.annualIndependence.dissagreementAnswer}`,margin:[0, 5, 0, 10]});
      docDefinition.content.push({text: `${this.annualIndependence.declaration}`,margin:[0, 15, 0, 10],bold:true});
      docDefinition.content.push({text: 'REPRESENTATION',margin:[0, 5, 0, 5],bold:true});
      docDefinition.content.push({text: `${this.annualIndependence.endText}`,margin:[0, 5, 0, 5],bold:true});
      docDefinition.content.push({text: `Sign:${'                      '} Yes`,margin: [0, 5, 0,4]});
      docDefinition.content.push({text: `Name:${'                    '}${this.annualIndependence.firstName} ${this.annualIndependence.lastName}`,margin:[0, 0, 0, 4]});
      docDefinition.content.push({text: `Designation:${'          '}${this.annualIndependence.role}`,margin:[0, 0, 0, 4]});
      docDefinition.content.push({text: `Date:${'                       '}${moment(this.annualIndependence.signedDate).format('DD-MMM-yyyy')}`,margin:[0, 0, 0, 4]});

    pdfMake.createPdf(docDefinition).download('PostAssignmentDeclaration.pdf');
  
  }
} 
